import { Meta } from '@/features/Meta';
import { Checkout as RegularCheckout } from './components/Checkout';
import { DigitalCheckout } from './components/DigitalCheckout';

interface CheckoutProps {
    type: 'order' | 'digital-order';
}

export const Checkout = (props: CheckoutProps) => (
    <>
        <Meta />
        {props.type === 'order' ? <RegularCheckout /> : <DigitalCheckout />}
    </>
);
